module.exports = __webpack_public_path__ + "img/uz.cb516839.jpg";